import { render, staticRenderFns } from "./instructionsHub.vue?vue&type=template&id=a3322372"
import script from "./instructionsHub.vue?vue&type=script&lang=js"
export * from "./instructionsHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports